import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from 'src/app/components/shared-components/image-dialog/image-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { Desk } from 'src/app/models/turns-models/desk.model';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';

@Component({
  selector: 'app-turns-desk-xl-photo-editor-card',
  templateUrl: './turns-desk-xl-photo-editor-card.component.html',
  styleUrls: ['./turns-desk-xl-photo-editor-card.component.scss']
})
export class TurnsDeskXlPhotoEditorCardComponent implements OnInit {

  @Input() deskInfo: Desk;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private desksTurnsService: DesksTurnsService,
    private snackbarService: SnackBarService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateImageDesk(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('desk-xl-image-spinner');
    this.desksTurnsService.updateImageDesk(this.deskInfo.InternalId, imageUrl, 'XL').subscribe(
      (res) => {
        this.desksTurnsService.refreshDesk();
        this.showSpinner = false;
        this.spinnerService.hide('desk-xl-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.desksTurnsService.refreshDesk();
        this.showSpinner = false;
        this.spinnerService.hide('desk-xl-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('desk-xl-image-spinner');
    this.desksTurnsService.updateImageDesk(this.deskInfo.InternalId, null, 'XL').subscribe(
      (res) => {
        this.desksTurnsService.refreshDesk();
        this.showSpinner = false;
        this.spinnerService.hide('desk-xl-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.desksTurnsService.refreshDesk();
        this.showSpinner = false;
        this.spinnerService.hide('desk-xl-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.deskInfo.ImageXl, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false, cropper: { width: 400, height: 250 } } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateImageDesk(result[0].Url);
        }

      });
  }

}
